import React from 'react'
import { connect } from 'react-redux'
import {
  noShrinkNoToolbarPaths,
  noShrinkPaths,
  matchSomePaths,
} from '../routes'

// HOC for shrink
export default (Component, className = '') => {
  const WrappedComponent = ({ shrink, ...passProps }) => {
    const alwaysShrink = !passProps.location
      ? false
      : matchSomePaths(passProps.location.pathname, noShrinkNoToolbarPaths) ||
          matchSomePaths(passProps.location.pathname, noShrinkPaths)

    return (
      <div
        className={`${className} ${alwaysShrink || shrink ? 'expanded' : 'collapsed'}`}>
        <Component {...passProps} />
      </div>
    )
  }

  return connect(state => ({ shrink: state.ui.topBarShrink }))(WrappedComponent)
}



// WEBPACK FOOTER //
// ./src/common/shrinked.js